import { getActiveTariff } from '@/fsd/entities/tariffs-and-payments';
import { Link } from '@/fsd/shared/ui';
import { useQuery } from '@tanstack/react-query';
import { differenceInDays, parseISO } from 'date-fns';
import { DAYS_LEFT_TO_SHOW_ACTIVE_TARIFF_BLOCK } from '../../model/consts/daysLeftToShowActiveTariffBlock';
import styles from './ActiveTariffsDaysLeftBlock.module.scss';

const ActiveTariffsDaysLeftBlock = () => {
  const { data: activeTariff, isLoading } = useQuery({
    queryKey: ['active-tariffs'],
    queryFn: getActiveTariff,
  });

  if (isLoading || !activeTariff?.data?.expires_at) return;

  const expiresAt = parseISO(activeTariff?.data?.expires_at);
  const daysLeft = differenceInDays(expiresAt, new Date());

  if (daysLeft > DAYS_LEFT_TO_SHOW_ACTIVE_TARIFF_BLOCK) return;

  return (
    <div className={styles.block}>
      <div className={styles.daysLeft}>{daysLeft <= 0 ? 0 : daysLeft}</div>
      <div className={styles.desc}>
        {daysLeft <= 0 ? (
          <Link to="tariffs-and-payments">Продлить подписку</Link>
        ) : (
          <>Дней до окончания подписки</>
        )}
      </div>
    </div>
  );
};

export default ActiveTariffsDaysLeftBlock;
